import { BaseModel } from "../BaseModel";
import {
	CurrentUserData,
	FeatureFlag,
	UserAuthorities,
	UserInfoProps,
	UserOrigin
} from "./types";
import { UserInfo } from "./UserInfo";

export class CurrentUser extends BaseModel<CurrentUserData> {
	id: string;
	name: string;
	email: string;
	origin: UserOrigin;
	authorities: UserAuthorities[];
	features: Record<FeatureFlag, boolean>;
	additionalInfo?: UserInfo;

	constructor(data: CurrentUserData) {
		super(data);
		this.id = data.id;
		this.name = data.name;
		this.email = data.email;
		this.origin = data.origin;
		this.authorities = data.authorities;
		this.features = data.features;
		this.setAdditionalInfo(data.additionalInfo);
	}

	setAdditionalInfo(userInfo: UserInfoProps) {
		this.additionalInfo = userInfo ? new UserInfo(userInfo) : undefined;
	}

	isExternalUser() {
		return this.origin === UserOrigin.EXTERNAL;
	}

	defaultRedirectUrl() {
		return this.isExternalUser() ? "/" : "/backoffice/";
	}

	hasCompletedRegistration() {
		return this.origin === UserOrigin.EXTERNAL && !!this.additionalInfo;
	}

	hasPermission(authority: UserAuthorities) {
		return this.authorities?.includes(authority);
	}

	hasBackofficePermission() {
		return this.hasPermission(UserAuthorities.ACESSO_SSO);
	}

	hasFeatureEnabled(feature: FeatureFlag) {
		return !!this.features?.[feature];
	}
}
